import { useMediaQuery } from "react-responsive";

const isMobile = () => useMediaQuery({ maxWidth: "992px" });
const isDesktop = () => useMediaQuery({ minWidth: "1200px" });

export const ResponsiveService = {
	isMobile,
	isDesktop,
};
